import { render, staticRenderFns } from "./ucl-quiz.vue?vue&type=template&id=12989838&scoped=true"
import script from "./ucl-quiz.vue?vue&type=script&setup=true&lang=js"
export * from "./ucl-quiz.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-spinner/dist/vue-spinner.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@ui-common/vue-form-notification/dist/vue-form-notification.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./ucl-quiz.vue?vue&type=style&index=2&id=12989838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12989838",
  null
  
)

export default component.exports